// extracted by mini-css-extract-plugin
export default {"notice":"index_notice__I8Yca","retryButton":"index_retryButton__ewRpI"};